/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function UpdateDocumentChatSettingRequestDocumentChatSettingFromJSON(json) {
    return UpdateDocumentChatSettingRequestDocumentChatSettingFromJSONTyped(json, false);
}
export function UpdateDocumentChatSettingRequestDocumentChatSettingFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        canChat: !exists(json, 'can_chat') ? undefined : json['can_chat']
    };
}
export function UpdateDocumentChatSettingRequestDocumentChatSettingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        can_chat: value.canChat
    };
}
